import { render, staticRenderFns } from "./afterSalesForm.vue?vue&type=template&id=a91fa612"
import script from "./afterSalesForm.vue?vue&type=script&lang=js"
export * from "./afterSalesForm.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports